import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../providers/globalState/GlobalStateProvider';
import { useStaticText } from '../../providers/staticText/staticTextProvider';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useData } from '../../providers/data/DataProvider';
import { useAnalytics } from '../../providers/analytics/AnalyticsProvider';

function Button() {
  const {
    buttonState,
    currentStep,
    struggles,
    setProgressBarValue,
    getResultOfVocabTest,
    STEPS
  } = useGlobalState();
  const { getStaticText } = useStaticText();
  const { data } = useData();
  const navigate = useNavigate();
  const [touched, setTouched] = useState<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const location = useLocation();
  const { track } = useAnalytics()
  const { language, isLangFromUserAgent } = useGlobalState()

  function click() {
    if (currentStep === "language") {
      track("Language Selected", {
        "language": data?.languages.find(x => x.id === language)?.iso,
        "isLangFromUserAgent": isLangFromUserAgent
      })
    }
    setTimeout(() => {
      let path = ""
      if (currentStep === "struggles") {
        path = `/struggleView/${struggles[0]}`
      } else if (currentStep === "struggleView") {
        const match = location.pathname.match(/^\/struggleView\/(\d+)$/);
        const struggleId = match ? Number(match[1]) : null;
        const currentStruggle = Number(struggleId)
        const currentIdx = struggles.indexOf(currentStruggle)
        if (currentIdx < struggles.length - 1) {
          path = `/struggleView/${struggles[currentIdx + 1]}`
        } else {
          const nextStep = STEPS[STEPS.indexOf(currentStep) + 1]
          path = `/${nextStep}`
        }
      } else if (currentStep === "grammarTest") {
        // Handle grammar test routing navigation
        const match = location.pathname.match(/^\/grammarTest\/(\d+)$/);
        const currentQuestionIndex = match ? parseInt(match[1], 10) : 0;
        const grammarTest = data?.grammar_test;

        if (grammarTest && currentQuestionIndex < grammarTest.questions.length - 1) {
          // Go to next question
          const nextIndex = currentQuestionIndex + 1;
          path = `/grammarTest/${nextIndex}`;

          // Update global progress bar
          // Calculate total steps dynamically: 3 vocab + 1 result + grammar questions
          const totalTestSteps = 3 + 1 + grammarTest.questions.length;
          const stepNumber = 4 + nextIndex + 1; // After vocab(3) + result(1) + next question
          const newProgress = 0.75 + (0.15 / totalTestSteps) * stepNumber;
          setProgressBarValue(newProgress);
        } else {
          // Last question, go to grammar test results
          path = `/grammarTestResults`
        }
      } else if (currentStep === "vocabularyTestAdvanced" && getResultOfVocabTest() === null) {
        path = `/grammarTest/0`
      } else {
        const nextStep = STEPS[STEPS.indexOf(currentStep) + 1]
        if (nextStep === "grammarTest") {
          path = `/grammarTest/0`
        } else if (nextStep === "lexTest") {
          path = `/lexTest/0`
        } else {
          path = `/${nextStep}`
        }
      }

      navigate(path);
    }, 300);
  }


  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;

    const handleDown = () => {
      setTouched(true);
    };

    const handleUp = () => {
      setTouched(false);
    };

    button.addEventListener('mousedown', handleDown);
    button.addEventListener('mouseup', handleUp);
    button.addEventListener('mouseleave', handleUp);
    button.addEventListener('touchstart', handleDown, { passive: true });
    button.addEventListener('touchend', handleUp);

    return () => {
      button.removeEventListener('mousedown', handleDown);
      button.removeEventListener('mouseup', handleUp);
      button.removeEventListener('mouseleave', handleUp);
      button.removeEventListener('touchstart', handleDown);
      button.removeEventListener('touchend', handleUp);
    };
  }, []);


  return (
    <div className={`${currentStep === "name" ? "button-component" : "button-component "}${buttonState === "gone" || currentStep === "email" ? "gone" : ""}`}>

      <button
        ref={buttonRef}
        onClick={click}
        disabled={buttonState === "disabled"}
        className={`button-border${touched ? " touched" : ""}`}
      >
        <div className='button'>
          {getStaticText("screen.practice.guide.control.next")}
        </div>
      </button>
    </div>
  );
}

export default Button;